import { render } from "./Blank.vue?vue&type=template&id=6d63ce3f"
import script from "./Blank.vue?vue&type=script&lang=js"
export * from "./Blank.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/aws.dot-account-site.US/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__